import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { continueLaterLocalization } from '@vwfs-its/sf-sac-frontend'

const BRAND_NAME = process.env.REACT_APP_WEBSITE_BRAND

const localization = continueLaterLocalization({
  locale: 'ie',
  brandName: { BRAND_NAME },
  dataProtectionLink: 'https://www.vwfs.ie/LegalNotice.html',
})

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {},
    lng: 'ie',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
      format: (value, format) => {
        if (typeof value !== 'string') return value

        if (format === 'lowercase') {
          return value.toLowerCase()
        }

        // No format applied
        return value
      },
    },
  })

i18n.addResourceBundle('ie', 'sf-sac', localization, true, true)

export default (brandName) =>
  new Promise((res) => {
    const namespaces = [
      'cookie',
      'validation',
      'form',
      'app',
      'error',
      'data',
      'summary',
      'contact',
      'completion',
      'link-expired',
      'authenticate',
      'upload',
      'upload-completion',
    ]
    Promise.all(
      namespaces.map((item) =>
        import(`../../resources/base/content/${item}.json`)
          .then((module) => {
            i18n.addResourceBundle('ie', item, module.default, true, true)
          })
          .then(() => {
            /**
             * Request brand-specific resources and override (using deep) the
             * resources for specific brand. Make sure to chain those to avoid
             * race conditions.
             */
            import(`../../resources/${brandName}/content/${item}.json`)
              .then((module) => {
                i18n.addResourceBundle('ie', item, module.default, true, true)
              })
              .catch(() => {})
          })
      )
    ).then(res)
  })
